import React from 'react';
import akshay from '../assests/images/akshay.jpg'

function InterestItem(props)
{
  return <li className="container has-icons-left">
          <div className="media">
            <div className="media-left">
              <i className={props.icon}></i>
            </div>
            <div className="media-content">
              <div className="container"></div>
              <p className="is-black has-text-weight-light is-para">
                {props.title}
              </p>
            </div>
          </div>
          <div className="container"></div>
        </li>
}

function Interests() {
  const interests = ['Machine Learning', 'Big Data Analytics', 'Computer Security', 'Software Design']
  const icons = ['fas fa-brain fa-xs', 'fas fa-server fa-xs', 'fas fa-user-secret fa-xs','fas fa-keyboard fa-xs']
  return interests.map(function(interest, index){
    return <InterestItem key={index} title={interest} icon={icons[index]}/>
  })
}

const About = () => {
    return (
        <div id="about" className="column has-text-centered is-fullheight">

          <div className="column has-text-centered">
            <p className="title is-5 is-blue has-text-bold is-heading padding-two-top">ABOUT</p>
          </div>
          <div className="column has-text-centered">
            <p className="subtitle is-3 is-black has-text-bold">
              Who am I?
            </p>
          </div>

          <div className="columns is-centered padding-two-top">
            <div className="column is-8">
              <div className="columns">
                <div className="column is-4-tablet has-text-centered">
                  <img className="ui bottom aligned centered small circular image margin-one-top" src={akshay}/>
                  {/* <figure className="image is-128x128">
                    <img className="is-rounded" src={akshay}/>
                  </figure> */}
                </div>
                <div className="column has-text-left-tablet">
                  <p className="has-text-justified is-para margin-one-top">
                  I'm a problem solver, life-long learner and a software developer based in Toronto, CA.
                  I enjoy constantly learning and improving my skills with the technologies that keep
                  evolving in this ever changing field! Lately, I’ve been intrigued by the potential of AI technologies 
                  and recently I was one of 10,000 recipients of the scholarship challenge deep learning course on Udacity 
                  from Facebook. I'm currently looking for full-time software engineering roles in Canada or US.   
                  </p>        
                </div>
              </div>
            </div>
          </div>

          <div className="columns is-centered padding-two-top">
            <div className="column is-8">
              <div className="columns">
                <div className="column is-half has-text-left has-text-centered-mobile">
                  <p className="title is-5 is-black has-text-bold">BACKGROUND</p>
                  <p className="has-text-justified is-para">
                  I've been passionate about technology since high school. 
                  Back then smartphones (especially Android & iOS) were just starting to evolve and one of my friends owned an HTC.
                  He showed me a chemical equation balancer app he built and that was the moment when I decided to pursue 
                  a career in technology.
                  </p>
                </div>

                <div className="column is-half has-text-left has-text-centered-mobile">
                  <p className="title is-5 is-black has-text-bold">INTERESTS</p>
                  <p className="has-text-justified is-para">
                    Although I love everything related to technology, these are the fields I'm most interested in:
                  </p>
                  <ul className="padding-one-top">
                      <Interests/>
                  </ul> 
                </div>
              </div>
            </div>
          </div>

        </div>
    );
};

export default About;